/* eslint-disable no-extend-native, unicorn/no-array-reverse, unicorn/no-array-sort, unicorn/consistent-function-scoping -- this file is a deliberate polyfill: it must extend native prototypes, and cannot use the very methods it defines. */

// ES2023 "change Array by copy" polyfills for older browsers.
//
// Vite/esbuild transpile syntax but do NOT polyfill built-in prototype methods,
// so `Array.prototype.toSorted` / `toReversed` ship raw into the client bundle and
// throw `toSorted is not a function` on browsers that predate ES2023 (Safari < 16.4).
// Both are used across the app: the landing's game list, session history, profile,
// recommended players.
//
// Exported as a function the client entry CALLS, rather than a bare side-effect import.
// `package.json` sets `"sideEffects": false`, which lets the bundler drop a module that
// is imported only for its side effects — and it did. Neither the pre-migration bundle
// (main-FgeABszp.js) nor the current one contains the polyfill, which is why Safari 15.6
// hit `E.toSorted is not a function` on the landing on 2026-08-04. An explicit call
// cannot be tree-shaken away regardless of bundler settings.
//
// Implemented as non-enumerable data properties (like the native methods) so they
// don't leak into `for...in`, and only when absent to avoid clobbering real impls.

export const installEs2023ArrayPolyfills = (): void => {
  if (typeof Array.prototype.toSorted !== 'function') {
    Object.defineProperty(Array.prototype, 'toSorted', {
      value: function toSorted<T>(this: T[], compareFn?: (a: T, b: T) => number): T[] {
        return Array.prototype.slice.call(this).sort(compareFn);
      },
      writable: true,
      configurable: true,
      enumerable: false,
    });
  }

  if (typeof Array.prototype.toReversed !== 'function') {
    Object.defineProperty(Array.prototype, 'toReversed', {
      value: function toReversed<T>(this: T[]): T[] {
        return Array.prototype.slice.call(this).reverse();
      },
      writable: true,
      configurable: true,
      enumerable: false,
    });
  }
};
